"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moment = _interopRequireDefault(require("moment"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _reactDates = require("react-dates");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    calendarRoot: {
      '& .DayPicker': {
        minHeight: 310,
        backgroundColor: 'none',
        boxShadow: 'none'
      },
      '& .CalendarMonth_caption': {
        fontSize: 16
      },
      '& .CalendarDay__default': {
        color: palette.link.main,
        border: 'none',
        fontSize: 12,
        fontWeight: 'bold'
      },
      '& .CalendarDay__hovered_span, & .CalendarDay__selected_span': {
        backgroundColor: palette.secondary.light,
        color: palette.text.primary,
        fontWeight: 'normal'
      },
      '& .CalendarDay__default:hover, & .CalendarDay__selected': {
        border: 'none',
        backgroundColor: palette.secondary.main,
        color: palette.text.primary,
        fontWeight: 'normal'
      },
      '& .CalendarDay__outside': {
        color: palette.grey.main,
        fontWeight: 'normal'
      },
      '& .CalendarDay__blocked_calendar, & .CalendarDay__blocked_calendar:hover': {
        color: palette.grey.main,
        backgroundColor: palette.grey.dark,
        fontWeight: 'normal'
      }
    },
    navIcon: {
      position: 'absolute',
      top: 22,
      color: palette.link.main
    },
    navIconRight: {
      right: 20
    },
    navIconLeft: {
      left: 20
    },
    bottomPanel: {
      fontSize: 12,
      height: 45,
      position: 'absolute',
      bottom: 0
    },
    link: {
      color: palette.link.main,
      fontWeight: 'bold'
    }
  };
});
/**
 * DateRangeSelectorCalendar.
 *
 * @function
 * @param {object} props
 * @param {string} [props.from=undefined]
 * @param {string} [props.to=undefined]
 * @param {string} [props.format]
 * @param {string} [props.displayFormat]
 * @param {Function} [props.onApply]
 * @param {Function} [props.onCancel]
 * @param {string} [props.dataTestId]
 * @param {string} [props.minDate]
 * @param {string} [props.maxDate]
 *
 * @returns {React.ReactNode}
 *
 * @example
 * // TODO: Add example.
 */

var DateRangeSelectorCalendar = function DateRangeSelectorCalendar(_ref2) {
  var from = _ref2.from,
      to = _ref2.to,
      format = _ref2.format,
      displayFormat = _ref2.displayFormat,
      onApply = _ref2.onApply,
      onCancel = _ref2.onCancel,
      dataTestId = _ref2.dataTestId,
      minDate = _ref2.minDate,
      maxDate = _ref2.maxDate;
  var classes = useStyles();
  var defaultRange = (0, _react.useMemo)(function () {
    return {
      from: from ? (0, _moment["default"])(from, format) : (0, _moment["default"])().utc().subtract(1, 'month'),
      to: to ? (0, _moment["default"])(to, format) : (0, _moment["default"])().utc()
    };
  }, [from, to, format]);

  var _useState = (0, _react.useState)(defaultRange),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      range = _useState2[0],
      setRange = _useState2[1];

  var renderRange = (0, _react.useCallback)(function () {
    return "\n        ".concat(range.from ? range.from.format(displayFormat) : '', "\n         - \n        ").concat(range.to ? range.to.format(displayFormat) : '', "\n      ");
  }, [range, displayFormat]);
  var handleChange = (0, _react.useCallback)(function (_ref3) {
    var startDate = _ref3.startDate,
        endDate = _ref3.endDate;
    setRange({
      from: startDate,
      to: endDate
    });
  }, []);
  var handleApply = (0, _react.useCallback)(function () {
    onApply({
      from: range.from.startOf('day').format(format),
      to: range.to.endOf('day').format(format)
    });
  }, [range, format, onApply]);
  var handleCancel = (0, _react.useCallback)(function () {
    setRange(defaultRange);
    onCancel();
  }, [defaultRange, onCancel]);

  var _useState3 = (0, _react.useState)('startDate'),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      focusedDay = _useState4[0],
      setFocusedDay = _useState4[1];

  var handleChangeFocusedDay = (0, _react.useCallback)(function (focused) {
    return setFocusedDay(focused || 'startDate');
  }, []);
  var minDay = (0, _react.useMemo)(function () {
    return (0, _moment["default"])(minDate, format);
  }, [format, minDate]);
  var maxDay = (0, _react.useMemo)(function () {
    return (0, _moment["default"])(maxDate, format);
  }, [format, maxDate]);
  var isDayBlocked = (0, _react.useCallback)(function (date) {
    if (minDay.isValid() && maxDay.isValid()) {
      return date.isBefore(minDay) || date.isSameOrAfter(maxDay);
    }

    if (minDay.isValid()) {
      return date.isBefore(minDay);
    }

    if (maxDay.isValid()) {
      return date.isSameOrAfter(maxDay);
    }

    return false;
  }, [minDay, maxDay]);
  var renderDay = (0, _react.useCallback)(function (date) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      "data-testid": "".concat(dataTestId, ".Custom.Day.").concat(date.format('YYYY-MM-DD'))
    }, isDayBlocked(date) ? /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
      title: "There is no data for this time period. Please select another date.",
      placement: "top"
    }, /*#__PURE__*/_react["default"].createElement("span", null, date.format('D'))) : date.format('D'));
  }, [dataTestId, isDayBlocked]);
  var navNextBtn = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "chevron-right",
      className: (0, _classnames["default"])(classes.navIcon, classes.navIconRight),
      "data-testid": "".concat(dataTestId, ".Custom.Next")
    });
  }, [classes, dataTestId]);
  var navPrevBtn = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "chevron-left",
      className: (0, _classnames["default"])(classes.navIcon, classes.navIconLeft),
      "data-testid": "".concat(dataTestId, ".Custom.Prev")
    });
  }, [classes, dataTestId]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.calendarRoot
  }, /*#__PURE__*/_react["default"].createElement(_reactDates.DayPickerRangeController, {
    startDate: range.from,
    endDate: range.to,
    onDatesChange: handleChange,
    focusedInput: focusedDay,
    onFocusChange: handleChangeFocusedDay,
    numberOfMonths: 2,
    hideKeyboardShortcutsPanel: true,
    enableOutsideDays: true,
    weekDayFormat: "ddd",
    daySize: 32,
    minimumNights: 0,
    renderDayContents: renderDay,
    isDayBlocked: isDayBlocked,
    navNext: navNextBtn,
    navPrev: navPrevBtn
  }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    alignItems: "center",
    pl: 3,
    pr: 3,
    width: 1,
    className: classes.bottomPanel
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    flexGrow: 1
  }, renderRange()), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    ml: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    onClick: handleCancel,
    variant: "text",
    size: "small",
    className: classes.link,
    "data-testid": "".concat(dataTestId, ".Custom.Cancel")
  }, "Cancel")), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    ml: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    onClick: handleApply,
    disabled: !range.from || !range.to,
    variant: "contained",
    color: "secondary",
    size: "small",
    "data-testid": "".concat(dataTestId, ".Custom.Apply")
  }, "Apply"))));
};

DateRangeSelectorCalendar.propTypes = {
  from: _propTypes["default"].string,
  to: _propTypes["default"].string,
  format: _propTypes["default"].string.isRequired,
  displayFormat: _propTypes["default"].string.isRequired,
  onApply: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  dataTestId: _propTypes["default"].string.isRequired,
  minDate: _propTypes["default"].string,
  maxDate: _propTypes["default"].string
};
DateRangeSelectorCalendar.defaultProps = {
  from: undefined,
  to: undefined,
  minDate: undefined,
  maxDate: undefined
};

var _default = /*#__PURE__*/(0, _react.memo)(DateRangeSelectorCalendar);

exports["default"] = _default;